<template>
  <div class="pageBox">
    <div class="content">
      <div class="appInfo">
        <div class="dataBox">
          <div class="imgBox">
            <el-image class="screenshot" :src="appDetail.appIcon">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="textBox">
            <p class="appName">{{ appDetail.appName }}</p>
            <p>包名：{{ appDetail.appPackage }}</p>

          </div>
          <div class="border"></div>
          <div>
            <p>链接名称：
              <span>{{ LinkDetail.linkName }}</span>
            </p>
            <p>链接状态：
              <span v-if="LinkDetail.showState==1">已冻结</span>
              <span v-if="LinkDetail.showState==2">已关闭</span>
              <span v-if="LinkDetail.showState==3">审核未通过</span>
              <span v-if="LinkDetail.showState==4">待审核</span>
              <span v-if="LinkDetail.showState==5">生效中</span>
            </p>
          </div>
        </div>
        <div v-if="LinkDetail.showState==5||LinkDetail.showState==2||LinkDetail.showState==1" class="changeBtn cursor" @click="onModify()">
          修改参数
        </div>
      </div>
      <el-table
          class="tableBox"
          :data="tableData"
          style="width: 100%">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column
            label="修改时间"
            align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.modifyTime| parseTime() }}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="状态"
            align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.reviewState==1">待审核</p>
            <p v-if="scope.row.reviewState==2">审核通过</p>
            <p v-if="scope.row.reviewState==3">审核不通过</p>
            <p v-if="scope.row.reviewState==4">主动撤回</p>
          </template>
        </el-table-column>
        <el-table-column
            label="参数"
            align="center">
          <template slot-scope="scope">
            <router-link
                :to="{path:'/console/appLink/link/reviseInfo',query:{appLinkAuditId:scope.row.appLinkAuditId,appName:appDetail.appName,}}">
              <el-button type="text">参数</el-button>
            </router-link>
            <el-button class="margin-l10" type="text" v-if="scope.row.reviewRemark && scope.row.reviewState !== 4" @click="onShowError(scope.row.reviewRemark)">
              原因
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      LinkDetail: {
        id: "",
        showState: "",
        linkName: "",
      },
      total: 0,
      appDetail: {},
      tableData: [],
    }
  },
  created() {
    this.LinkDetail.id = this.$route.query.id;
    this.LinkDetail.showState = this.$route.query.showState;
    this.LinkDetail.linkName = this.$route.query.linkName;
    this.queryIdentifyLastDetail();
    this.queryLinkPage();
  },
  mounted() {

  },
  methods: {
    onModify() {
      this.$router.push({
        path: '/console/appLink/link/modify',
        query: {
          appName: this.appDetail.appName,
          appLinkAuditId: this.tableData[0]['appLinkAuditId'],
        }
      });
    },
    //获取应用信息
    queryIdentifyLastDetail() {
      this.$apis.consoleSever.queryDetail({
        id: this.$route.query.appId,
      }).then(res => {
        if (res.code == 0) {
          this.appDetail = res.data;
          // 设置面包屑下拉选项
          // this.$store.commit("breadcrumbStore/setKeyBreadcrumb", {
          //   key: this.$route.meta.key, 
          //   name:this.appDetail.apkName, 
          //   path: this.$route.fullPath, 
          //   requestUrl:'/api/identifyApk/queryList'
          // });
        }
      })
    },
    queryLinkPage() {
      this.$apis.consoleSever
          .queryModifyPage({
            appLinkId: this.LinkDetail.id,
          }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onShowError(item) {
      this.$alert(item, {
        title: "审核未通过原因",
      }).then(_ => {
        done();
      })
    },
  }
}
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: 900px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .pointer {
    cursor: pointer;

  }

  .content {
    min-height: 800px;
    background: #fff;
    box-shadow: $--background-shadow-base;
    overflow: hidden;
    padding: 30px;

    .appInfo {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;

      .dataBox {
        display: flex;
        align-items: center;
        height: 100px;

        & > div {
          height: 100%;
          display: flex;
          flex-direction: column;

          p {
            margin-bottom: 8px;
            font-size: 16px;
            height: 30px;
            line-height: 30px;
          }
        }

        .imgBox {
          width: 100px;
          height: 100px;
          border-radius: 10px;
          margin-right: 19px;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        .textBox {
          .appName {
            font-size: 24px;
            color: #000000;
            font-weight: bold;
            margin-bottom: 8px;
          }
        }

        .border {
          margin: 0 20px;
          width: 1px;
          background: #ccc;
        }
      }
    }

    .changeBtn {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border: 1px solid #ccc;
      border-radius: 5px;

      &:hover {
        color: #2E84FC;
        // font-weight: bold;
        background: rgba(46, 132, 252, 0.1);
      }
    }

  }
}
</style>
